var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';

function SvgPhone(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M16.888 6.586l5.293-5.293a1 1 0 011.414 1.414L18.302 8h3.586a1 1 0 110 2h-6a1 1 0 01-1-1V3a1 1 0 012 0v3.586zm6 11.345v2.985a3 3 0 01-3.288 2.998 20.78 20.78 0 01-9.058-3.22 20.49 20.49 0 01-6.303-6.3A20.805 20.805 0 011.012 5.27 3 3 0 013.998 2h2.99A3.002 3.002 0 019.99 4.59c.116.885.333 1.754.644 2.588a3.002 3.002 0 01-.679 3.17l-.717.716a15 15 0 004.586 4.586l.721-.721a3 3 0 013.163-.676c.836.312 1.706.529 2.6.647a3 3 0 012.58 3.031zm-2-.011c.013-.532-.357-.969-.85-1.039a13.845 13.845 0 01-3.032-.755.998.998 0 00-1.05.221l-1.27 1.27a1 1 0 01-1.202.162 17 17 0 01-6.375-6.375 1 1 0 01.162-1.201l1.266-1.266a1 1 0 00.224-1.057 13.817 13.817 0 01-.753-3.02A1.003 1.003 0 006.998 4H4a1 1 0 00-.996 1.074 18.8 18.8 0 002.92 8.24 18.511 18.511 0 005.7 5.697 18.774 18.774 0 008.175 2.913 1 1 0 001.09-1.004v-3z"
  }));
}

export default SvgPhone;